import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import {AuthService} from "./auth.service";
import {RoleEnum} from "./role.enum";

@Injectable({
  providedIn: 'root'
})
export class RoleGuard  {
  private authService = inject(AuthService);
  private router = inject(Router);


  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    if (this.authService.user() === null) {
      await this.authService.fetchMe();
    }

    const roleId = this.authService.user()!.role.id;
    if (route.data["roles"].includes(roleId)) {
      return true;
    }
    if (roleId === RoleEnum.Basic || roleId === RoleEnum.READ) {
      void this.router.navigate(["pickup"]);
    } else if (roleId === RoleEnum.READ_CUSTOMERS) {
      void this.router.navigate(["customers"]);
    } else {
      void this.router.navigate(["home"]);
    }
    return false;
  }

}
